// extracted by mini-css-extract-plugin
export default {"bottomInputContainer":"styles_bottomInputContainer__jI0zX","checkbox":"styles_checkbox__KECQn","active":"styles_active__GDga+","label":"styles_label__0HYN-"};